import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { MatDialog } from "@angular/material/dialog";
import { SessionTimeoutDialogComponent } from "../components/session-timeout-dialog/session-timeout-dialog.component";
import { LoggedOutDialogComponent } from "../components/logged-out-dialog/logged-out-dialog.component";
import { CustomerService } from "./customer.service";

@Injectable({
  providedIn: "root"
})
export class SessionTimeoutService
{
  idleTimeout: any;
  idleThresholdMinutes: number = 10;
  idleThreshold: number = this.idleThresholdMinutes * 60 * 1000;
  listener: any;

  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private customerService: CustomerService
  )
  { }

  setupEventListeners(): void
  {
    this.listener = () => this.resetTimeoutTimer();
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach((event) =>
    {
      document.addEventListener(event, this.listener);
    });
  }

  removeEventListeners(): void
  {
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach((event) =>
    {
      document.removeEventListener(event, this.listener);
    });
  }

  resetTimeoutTimer(): void
  {
    if (this.idleTimeout)
    {
      clearTimeout(this.idleTimeout);
    }
    this.idleTimeout = setTimeout(() => this.openWarning(), this.idleThreshold);
  }

  openWarning()
  {
    this.stopTimeoutTimer();
    const dialogRef = this.dialog.open(SessionTimeoutDialogComponent, {
      disableClose: true,
      data: { title: "30 second warning", idleThresholdMinutes: this.idleThresholdMinutes }
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result === false)
      {
        this.dialog.closeAll();
        this.logoutFromTimeout();
      }
      if (result === 'auto-closed')
      {
        this.dialog.closeAll();
        this.logoutFromTimeout();
        this.dialog.open(LoggedOutDialogComponent);
      }
      else
      {
        this.resetTimeoutTimer();
        this.setupEventListeners();
      }
    });
  }

  logoutFromTimeout()
  {
    this.authService.logout();
    this.customerService.clearCustomerData();
    this.stopTimeoutTimer();
  }

  stopTimeoutTimer(): void
  {
    clearTimeout(this.idleTimeout);
    this.removeEventListeners();
  }

}
